/**
 * Agora Metrics Constants
 */

// Processing intervals
export const DEFAULT_PROCESSING_INTERVAL_MS = 2000;
export const QUALITY_LOG_SAMPLE_COUNT = 10;

// Network health constants
export const NETWORK_HEALTH_EXCELLENT = 'excellent';
export const NETWORK_HEALTH_GOOD = 'good';
export const NETWORK_HEALTH_POOR = 'poor';

// Resolution constants
export const DEFAULT_EXPECTED_RESOLUTION_HEIGHT = 720;
export const OFFSTAGE_MAX_EXPECTED_RESOLUTION_HEIGHT = 240;
export const FALLBACK_RESOLUTION_HEIGHT = 480;
export const MIN_GOOD_RESOLUTION_HEIGHT = 360;

// Quality score thresholds
export const MOS_EXCELLENT_THRESHOLD = 4;
export const MOS_GOOD_THRESHOLD = 3;

export const QUALITY_SCORE_EXCELLENT = 3;
export const QUALITY_SCORE_GOOD = 2;
export const QUALITY_SCORE_POOR = 1;

// FPS thresholds for different contexts
export const FPS_ONSTAGE_EXCELLENT_THRESHOLD = 15;
export const FPS_ONSTAGE_GOOD_THRESHOLD = 10;
export const FPS_OFFSTAGE_EXCELLENT_THRESHOLD = 10;
export const FPS_OFFSTAGE_GOOD_THRESHOLD = 5;

// Network quality mapping from Agora numeric values to string values
export const AGORA_NETWORK_QUALITY_TO_STRING_MAP: { [key: number]: string } = {
  0: 'unknown',
  1: NETWORK_HEALTH_EXCELLENT,
  2: NETWORK_HEALTH_GOOD,
  3: NETWORK_HEALTH_POOR,
  4: NETWORK_HEALTH_POOR,
  5: NETWORK_HEALTH_POOR,
  6: NETWORK_HEALTH_POOR
};

// Quality score to network health mapping
export const SCORE_QUALITY_MAP = {
  1: NETWORK_HEALTH_POOR,
  2: NETWORK_HEALTH_GOOD,
  3: NETWORK_HEALTH_EXCELLENT
} as const;

// Default codec type
export const DEFAULT_CODEC = 'unknown';

// MOS calculation constants
export const MOS_BASE_R_FACTOR = 93.2;
export const MOS_HIGH_LATENCY_THRESHOLD = 160;
export const MOS_LATENCY_FACTOR_NORMAL = 40;
export const MOS_LATENCY_FACTOR_HIGH = 120;
export const MOS_HIGH_LATENCY_PENALTY = 10;
export const MOS_PACKET_LOSS_MULTIPLIER = 2.5;
export const MOS_JITTER_MULTIPLIER = 2;
export const MOS_BASE_LATENCY_OFFSET = 10;
export const MOS_CALCULATION_CONSTANT_A = 1;
export const MOS_CALCULATION_CONSTANT_B = 0.035;
export const MOS_CALCULATION_CONSTANT_C = 0.000007;
export const MOS_CALCULATION_R_FACTOR_OFFSET = 60;
export const MOS_CALCULATION_MAX_R_FACTOR = 100;
